'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-props-no-spreading */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@material-ui/core');

var _ = require('..');

var _dialog = require('../../schema/component/dialog.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// eslint-disable-next-line react/display-name
var Transition = (0, _react.forwardRef)(function (props, ref) {
  return _react2.default.createElement(_core.Slide, _extends({ direction: 'up', ref: ref }, props));
});

var useStyles = (0, _core.makeStyles)({
  container: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: '280px'
    }
  },
  image: {
    background: function background(_ref) {
      var image = _ref.image;
      return 'var(--onprimary-high-emphasis) url(' + image + ') no-repeat left top';
    },
    backgroundSize: 'cover !important',
    height: function height(_ref2) {
      var image = _ref2.image;
      return image ? '140px' : '0px';
    }
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    '& .alert': {
      color: 'var(--error)',
      marginRight: '16px'
    }
  },
  content: {
    background: 'var(--onsurface-primary)',
    padding: '24px 24px 16px'
  },
  actions: {
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-end',
    marginLeft: 'calc(-21px / 2)',
    width: 'calc(100% + 21px)'
  },
  action: {
    height: function height(_ref3) {
      var actionHeight = _ref3.actionHeight;
      return actionHeight + ' !important';
    },
    padding: function padding(_ref4) {
      var actionPadding = _ref4.actionPadding;
      return actionPadding + ' !important';
    }
  }
});

var Dialog = function Dialog(_ref5) {
  var image = _ref5.image,
      title = _ref5.title,
      titleVariant = _ref5.titleVariant,
      TitleIcon = _ref5.TitleIcon,
      message = _ref5.message,
      messageVariant = _ref5.messageVariant,
      actions = _ref5.actions,
      variant = _ref5.variant,
      props = _objectWithoutProperties(_ref5, ['image', 'title', 'titleVariant', 'TitleIcon', 'message', 'messageVariant', 'actions', 'variant']);

  var variantDefault = _dialog.properties.alert.properties;
  var variantSelected = _dialog.properties[variant] && _dialog.properties[variant].properties;
  var variantValidation = variantSelected || variantDefault;
  var classes = useStyles({
    actionHeight: variantValidation.actionHeight,
    actionPadding: variantValidation.actionPadding,
    image: image
  });
  return _react2.default.createElement(
    _core.Dialog,
    _extends({
      TransitionComponent: Transition,
      keepMounted: true,
      className: classes.container
    }, props),
    variantValidation.isImage && _react2.default.createElement('div', { className: classes.image }),
    _react2.default.createElement(
      'div',
      { className: classes.content },
      variantValidation.isTitle && title && _react2.default.createElement(
        _.Typography,
        {
          className: classes.title,
          variant: titleVariant,
          'data-margin-bottom': '12px'
        },
        variantValidation.isTitleIcon && TitleIcon && _react2.default.createElement(TitleIcon, { className: 'alert' }),
        _react2.default.createElement(
          'span',
          null,
          title
        )
      ),
      _react2.default.createElement(
        _.Typography,
        { variant: messageVariant, 'data-margin-bottom': '6px' },
        message
      ),
      _react2.default.createElement(
        'div',
        { className: classes.actions },
        actions && actions.map(function (row, index) {
          return _react2.default.createElement(
            _.Button,
            {
              key: row.text,
              className: classes.action,
              onClick: row.onClick,
              type: row.variant || 'text-primary',
              'data-margin-right': actions.length > 0 && index + 1 === actions.length ? '0px' : '8px'
            },
            row.text
          );
        })
      )
    )
  );
};

exports.Dialog = Dialog;
Dialog.defaultProps = {
  actions: [{
    onClick: function onClick() {},
    text: 'Button'
  }, {
    onClick: function onClick() {},
    text: 'Button'
  }],
  image: null,
  messageVariant: 'textbody1-reguler',
  title: null,
  TitleIcon: null,
  titleVariant: 'h6',
  variant: 'alert'
};

Dialog.propTypes = {
  actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    onClick: _propTypes2.default.func,
    text: _propTypes2.default.string
  })),
  image: _propTypes2.default.string,
  message: _propTypes2.default.string.isRequired,
  messageVariant: _propTypes2.default.string,
  title: _propTypes2.default.string,
  TitleIcon: _propTypes2.default.node,
  titleVariant: _propTypes2.default.string,
  variant: _propTypes2.default.string
};

exports.default = Dialog;